import { USER_LOGIN, USER_LOGOUT } from "../mutation-types";

const state = {
  user: null
};

const mutations = {
  // 用户登录
  [USER_LOGIN]: (state, user) => {
    sessionStorage.setItem("user", JSON.stringify(user)); //添加到sessionStorage
    state.user = user;
  },
  // 用户登出
  [USER_LOGOUT]: state => {
    sessionStorage.removeItem("user"); //移除sessionStorage
    state.user = null;
  }
};

const actions = {
  // 用户登录
  login({ commit }, user) {
    commit("USER_LOGIN", user);
  },
  // 用户登出
  logout({ commit }) {
    commit("USER_LOGOUT");
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
